import { useState, useRef } from 'react';
import { useTheme } from '@/contexts/themeContext';
import styles from './Sidebar.module.scss';
import { motion } from 'framer-motion';

import Logo from '@/assets/images/logo_white.png';
import UserProfileDropdown from '@/components/Elements/SidebarProfile';
import { Button, Drawer, Grid } from 'antd';

import { Scrollbars } from 'rc-scrollbars';
import { Menu } from 'lucide-react';
import UpdatedMenuList from '../MenuList/UpdatedMenu';
const { useBreakpoint } = Grid;

const sidebarVariants = {
  expanded: { width: 250, opacity: 1, transition: { duration: 0.3 } },
  collapsed: { width: 90, opacity: 1, transition: { duration: 0.3 } },
};

const Sidebar = () => {
  const { sidebarCollapseState, toggleSidebarState } = useTheme();
  const [isManuallyToggled, setIsManuallyToggled] = useState(true);
  const hoverTimeout = useRef<NodeJS.Timeout | null>(null);

  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const handleMouseEnter = () => {
    if (sidebarCollapseState) {
      // Delay expansion by 500ms
      hoverTimeout.current = setTimeout(() => {
        toggleSidebarState();
      }, 300);
    }
  };

  const handleMouseLeave = () => {
    if (hoverTimeout.current) {
      clearTimeout(hoverTimeout.current); // Prevent expansion if hover is too short
    }

    if (!sidebarCollapseState && !isManuallyToggled) {
      setTimeout(() => {
        toggleSidebarState();
      }, 300); // Slight delay for smooth collapse
    }
  };

  const handleMenuClick = () => {
    setIsManuallyToggled((prev) => !prev);
    toggleSidebarState();
  };

  return (
    <>
      {isMobile ? (
        <Drawer
          open={sidebarCollapseState}
          onClose={handleMenuClick}
          placement="left"
          width={250}
        >
          <div className={styles['sidebar-container']}>
            <div className={styles['sidebar-logo-container']}>
              <img src={Logo} alt="Odin Mortgage" />
            </div>
            <div className={styles['sidebar-body']}>
              <UpdatedMenuList isMobile={true} />
            </div>
          </div>
        </Drawer>
      ) : (
        <motion.div
          initial={false}
          animate={sidebarCollapseState ? 'collapsed' : 'expanded'}
          variants={sidebarVariants}
          className={styles['sidebar-container']}
        >
          <div className="sidebar">
            <div className={styles['sidebar-logo-container']}>
              <img
                src={Logo}
                style={{
                  width: sidebarCollapseState ? '0%' : '100%',
                  paddingRight: sidebarCollapseState ? '0' : '1rem',
                  transition: 'width 0.5s ease, padding 0.5s ease',
                }}
                alt="Odin Mortgage"
              />
              <Button
                onClick={handleMenuClick}
                type="text"
                icon={
                  <Menu
                    strokeWidth={1.25}
                    style={{ fontSize: '22px', color: '#fff' }}
                  />
                }
              />
            </div>
            <div
              className={styles['sidebar-body']}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <UpdatedMenuList />
              <Scrollbars />
            </div>
          </div>
          <div
            style={{
              width: sidebarCollapseState ? '80%' : '90%',
              backgroundColor: sidebarCollapseState ? 'transparent' : '',
              transition: 'all 0.5s ease',
            }}
            className={styles['sidebar-bottom-container']}
          >
            <UserProfileDropdown />
          </div>
        </motion.div>
      )}
    </>
  );
};

export default Sidebar;
